import styled from "styled-components";
import colors from "@/constants/systemColors";
export const Container = styled.div`
    width: 100%;
    height: 62px;
    position: absolute;
    top: -60px; 
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 15px 20px; 
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    color: ${colors.brand.white};
    transition: all 0.3s ease-in-out; 
    overflow: hidden;

    background-color: rgba(255, 50, 25, .9);
    background-blur: 10px;

`;

export const LogoutButton = styled.div`

    opacity: 1 ;
    transition: opacity 0.3s ease-in-out;
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const UserInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
    
    pointer-events: auto;
`;

export const Message = styled.span`
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
`;

export const UserName = styled.span`
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
`;


export const LogoutText = styled.span`
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    color: ${colors.brand.white};
`;